module.exports = __webpack_public_path__ + "img/crock-pot-caribbean-chicken.dbe2854a.jpg";